export function buildArticleEditorConfig(onOpenMediaPicker) {
    return {
        readonly: false,
        height: '80vh',
        disablePlugins: ['powered-by-jodit', 'file'],
        controls: {
            image: {
                exec: (jodit) => {
                    onOpenMediaPicker(jodit);
                },
            },
        },
    };
}

export function resolveJoditInstance(refOrInstance) {
    const value = refOrInstance?.current ?? refOrInstance;
    if (!value) {
        return null;
    }

    return value.s ? value : value.editor ?? null;
}

export function insertImageIntoEditor(joditRef, imagePath) {
    const jodit = resolveJoditInstance(joditRef);
    if (!jodit?.s || !imagePath) {
        return false;
    }

    jodit.s.restore();
    jodit.s.insertImage(imagePath, null, '100%');
    jodit.synchronizeValues();
    jodit.e.fire('change');
    jodit.e.fire('change.placeholder');
    jodit.s.focus();
    return true;
}
